<template>
  <SelosPage
    slug="funarpen-valores-dos-selos"
    titulo="Selos - Tabela de Preços"
  >
    <template #form-description>
      <div class="form-description">
        <p>Em cumprimento à Lei Estadual N° 21.339/22.</p>
      </div>
    </template>
  </SelosPage>
</template>

<script lang="ts">
import SelosPage from '~/components/Lista.vue'
export default { components: { SelosPage } }
</script>

<script setup lang="ts">
definePageMeta({
  title: 'FUNARPEN - Selos',
  middleware: 'manutencao',
})

useHead({
  title: 'Selos',
  meta: [{ name: 'description', content: 'Selos' }],
})
</script>

<style scoped>
.form-description {
  padding: 1rem 1.25rem;
  background-color: rgba(11, 79, 108, 0.08);
  border-left: 4px solid var(--funarpen-gold);
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.form-description p {
  margin: 0;
  color: var(--funarpen-ink);
  font-size: 0.95rem;
  line-height: 1.5;
}
</style>
